export enum ReportsRoutes {
  Last7Days = "/reports/last-7-days",
  NewTickets = "/reports/new-tickets",
  TicketSatisfaction = "/reports/ticket-satisfaction",
  FirstResponseTime = "/reports/first-response-time",
  SolvedAndClosed = "/reports/solved-and-closed",
  TicketResolutionTime = "/reports/ticket-resolution-time",
  HandlingTimeByStatus = "/reports/handling-time-by-status",
  GenerateReport = "/reports/generate-report",
  AuditLog = "/reports/audit-log",
}
